import type CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import shouldEnableDefaultOnlineMeeting from './shouldEnableDefaultOnlineMeeting';
import { differenceInDays } from 'owa-datetime';
import { getDefaultCalendar } from 'owa-calendar-cache';
import LocalCalendarEntry from 'owa-service/lib/contract/LocalCalendarEntry';
import { lazyLaunchThirdPartyOnlineMeetingProviderAddin } from 'owa-addins-core';

/**
 * Enables default online meeting for 3P for new meetings
 * @param event
 * @return false in case of addin launch failure. true otherwise.
 */
export default function launchThirdPartyOnlineMeetingProvider(
    hostItemIndex: string,
    event: CalendarEvent,
    formId: string
) {
    /* Do not auto launch 3P online meeting provider addins if
       1. shouldEnableDefaultOnlineMeeting() is false or
       2. This is a multiday or an all-day meeting */
    if (
        !shouldEnableDefaultOnlineMeeting(event, formId) ||
        differenceInDays(event.End, event.Start) > 0 ||
        event.IsAllDayEvent
    ) {
        return false;
    }

    const calendarEntry: LocalCalendarEntry = getDefaultCalendar() as LocalCalendarEntry;
    return lazyLaunchThirdPartyOnlineMeetingProviderAddin.importAndExecute(
        hostItemIndex,
        calendarEntry?.DefaultOnlineMeetingProvider,
        window /* [PP] pass targetWindow from here */
    );
}
